import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListaManutencao from "./components";

function ManutencaoListaPage() {
  useBreadcrumb([
    { name: "Administração" },
    {
      name: "Controle de Manutenção",
    },
  ]);
  return (
    <Container>
      <ListaManutencao />
    </Container>
  );
}

export default ManutencaoListaPage;
